const getItemById = (items, id) => items.find((item) => item.id === id) || {};

export default getItemById;
